var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// Small presentational primitives shared across the Move V2 step views.
export var Row = function (_a) {
    var label = _a.label, value = _a.value;
    return (_jsxs("div", __assign({ className: 'flex flex-row justify-between' }, { children: [_jsx("span", __assign({ className: 'text-gray-400' }, { children: label }), void 0), _jsx("span", __assign({ className: 'text-right font-medium' }, { children: value }), void 0)] }), void 0));
};
export var PickButton = function (_a) {
    var label = _a.label, sub = _a.sub, onClick = _a.onClick;
    return (_jsxs("button", __assign({ type: 'button', onClick: onClick, className: 'w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-left hover:border-primary' }, { children: [_jsx("p", __assign({ className: 'text-sm font-semibold text-gray-700' }, { children: label }), void 0), sub && _jsx("p", __assign({ className: 'text-xs text-gray-400' }, { children: sub }), void 0)] }), void 0));
};
